import React, { useContext } from 'react';
import { Box, Container, SxProps } from '@mui/material';
import { UIContext } from '../context/UIContext';

const ActionsContainer = ({
  children,
  containerSx,
}: {
  children: JSX.Element | JSX.Element[];
  containerSx?: SxProps;
}) => {
  const { colorMode } = useContext(UIContext);

  return (
    <Box
      sx={{
        display: 'flex',
        position: 'fixed',
        bottom: 0,
        left: 0,
        height: '4rem',
        width: '100%',
        zIndex: 2,
        backgroundColor: 'background.paper',
        borderTop: (theme) =>
          `1px ${
            colorMode === 'light' ? theme?.palette?.grey?.['12p'] : theme?.palette?.grey?.['23p']
          } solid`,
      }}
    >
      <Container
        sx={{
          paddingY: 1,
          paddingX: { xs: 2, lg: 3 },
          display: 'flex',
          justifyContent: 'space-between',
          textAlign: 'center',
          ...containerSx,
        }}
      >
        {children}
      </Container>
    </Box>
  );
};

export default ActionsContainer;
